import AnimatedPage from "../components/animatedPage"
import Banner from "../components/banner/banner"
import { DecodeHtml } from "../utils/decodeHtml"
import { retrunAssets } from "../utils/getAssets"
import useFetch from "../utils/useFetch"
import YouTubeEmbed from "../utils/youtubeEmbed"

const SmartApps = () => {

    const url = "student-hub/uniten-smart-apps"
    const state = useFetch(url)
    const data = state?.properties
    const title = data?.title
    const bg = data?.backgroundImage != null ? retrunAssets(data?.backgroundImage[0]?.url) : ""


    return (
        <AnimatedPage>
            <Banner text={title} bg={bg} />
            <div className="flex items-center justify-center p-8 md:px-12 ">
                <div className="flex flex-col gap-8 w-full ">
                    {
                        data?.contents?.items?.map((item, index) => {
                            item = item?.content?.properties
                            return (
                                <div key={index} className={`flex  gap-8 ${index == 0 ? "flex-col-reverse md:flex-row-reverse" : 'md:flex-row flex-col'} w-full justify-between`}>
                                    {
                                        item?.image != null ?
                                            (
                                                <div className="w-full md:w-1/2">
                                                    <div className={`w-[${item?.image[0]?.width}px] h-[${item?.image[0]?.height}px]`}>
                                                        <img src={retrunAssets(item?.image[0]?.url)} alt={item?.title} className="w-full h-full object-cover" />
                                                    </div>
                                                </div>
                                            )
                                            :
                                            <div className="min-h-[20rem] w-full md:w-1/2">
                                                <YouTubeEmbed videoUrl={item?.youtubeLinkURL} />
                                            </div>
                                    }
                                    <p className="whitespace-pre-line font-normal w-full md:w-1/2">
                                        {DecodeHtml({ html: item?.contents?.markup })}
                                    </p>

                                </div>
                            )
                        })

                    }

                </div>
            </div>
        </AnimatedPage>
    )
}

export default SmartApps